const quotationMarks = {
    'af-ZA': { open: '“', close: '”' },
    'ar-SA': { open: '«', close: '»' },
    'be-BY': { open: '«', close: '»' },
    'bg-BG': { open: '„', close: '“' },
    'bn-BD': { open: '“', close: '”' },
    'bs-BA': { open: '„', close: '“' },
    'ca-ES': { open: '«', close: '»' },
    'cs-CZ': { open: '„', close: '“' },
    'cy-GB': { open: '“', close: '”' },
    'da-DK': { open: '”', close: '”' },
    'de-DE': { open: '„', close: '“' },
    'el-GR': { open: '«', close: '»' },
    'en-GB': { open: '‘', close: '’' },
    'en-US': { open: '“', close: '”' },
    'eo-EO': { open: '“', close: '”' },
    'es-ES': { open: '«', close: '»' },
    'et-EE': { open: '„', close: '“' },
    'eu-ES': { open: '«', close: '»' },
    'fa-IR': { open: '«', close: '»' },
    'fi-FI': { open: '”', close: '”' },
    'fr-FR': { open: '«', close: '»' },
    'fy-NL': { open: '“', close: '”' },
    'ga-IE': { open: '“', close: '”' },
    'he-IL': { open: '„', close: '“' },
    'hi-IN': { open: '“', close: '”' },
    'hr-HR': { open: '„', close: '“' },
    'hu-HU': { open: '„', close: '”' },
    'hy-AM': { open: '«', close: '»' },
    'id-ID': { open: '“', close: '”' },
    'is-IS': { open: '„', close: '“' },
    'it-IT': { open: '«', close: '»' },
    'ja-JP': { open: '「', close: '」' },
    'kn-IN': { open: '“', close: '”' },
    'ko-KR': { open: '“', close: '”' },
    'lt-LT': { open: '„', close: '“' },
    'lv-LV': { open: '„', close: '“' },
    'ml-IN': { open: '“', close: '”' },
    'nl-NL': { open: '“', close: '”' },
    'no-NO': { open: '”', close: '”' },
    'pl-PL': { open: '„', close: '”' },
    'ps-AF': { open: '«', close: '»' },
    'ro-RO': { open: '„', close: '”' },
    'ru-RU': { open: '«', close: '»' },
    'sk-SK': { open: '„', close: '“' },
    'sl-SI': { open: '„', close: '“' },
    'sq-AL': { open: '“', close: '”' },
    'sv-SE': { open: '”', close: '”' },
    'sw-KE': { open: '“', close: '”' },
    'ta-IN': { open: '“', close: '”' },
    'te-IN': { open: '“', close: '”' },
    'th-TH': { open: '“', close: '”' },
    'tr-TR': { open: '“', close: '”' },
    'uk-UA': { open: '«', close: '»' },
    'ur-PK': { open: '«', close: '»' },
    'vi-VN': { open: '“', close: '”' },
    'zh-CN': { open: '「', close: '」' },
};
const defaultQuotationMarks = { open: '“', close: '”' };
export const getQuotationMarksByLocale = (locale) => {
    var _a;
    if (locale === null) {
        return defaultQuotationMarks;
    }
    return (_a = quotationMarks[locale.code]) !== null && _a !== void 0 ? _a : defaultQuotationMarks;
};
